// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-container {
    position: relative;
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    justify-content: center; 
    align-items: flex-start;
}

.docx-container {
    position: relative;
    width: 100%;
    height: auto;
    overflow: auto;
    display: flex;
    justify-content: center; 
    align-items: flex-start;
}

.pdf-canvas,
.docx-container,
.annotation-canvas {
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
}

.annotation-canvas {
    pointer-events: auto;
    z-index: 10;
}

.pdf-canvas {
    pointer-events: none;
}

/* DOCX Table Styles */
/* .docx-wrapper table {
    border-collapse: collapse;
    width: 100%;
    margin: 10px 0;
}

.docx-wrapper td,
.docx-wrapper th {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}

.docx-wrapper th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.docx-wrapper tr:nth-child(even) {
    background-color: #f9f9f9;
}

.docx-wrapper tr:hover {
    background-color: #f5f5f5;
} */`, "",{"version":3,"sources":["webpack://./src/containers/Extraction/Documents/ViewDocument/styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA,sBAAsB;AACtB;;;;;;;;;;;;;;;;;;;;;;;;GAwBG","sourcesContent":[".pdf-container {\n    position: relative;\n    width: 100%;\n    height: auto;\n    overflow: hidden;\n    display: flex;\n    justify-content: center; \n    align-items: flex-start;\n}\n\n.docx-container {\n    position: relative;\n    width: 100%;\n    height: auto;\n    overflow: auto;\n    display: flex;\n    justify-content: center; \n    align-items: flex-start;\n}\n\n.pdf-canvas,\n.docx-container,\n.annotation-canvas {\n    width: 100%;\n    height: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n}\n\n.annotation-canvas {\n    pointer-events: auto;\n    z-index: 10;\n}\n\n.pdf-canvas {\n    pointer-events: none;\n}\n\n/* DOCX Table Styles */\n/* .docx-wrapper table {\n    border-collapse: collapse;\n    width: 100%;\n    margin: 10px 0;\n}\n\n.docx-wrapper td,\n.docx-wrapper th {\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: left;\n}\n\n.docx-wrapper th {\n    background-color: #f2f2f2;\n    font-weight: bold;\n}\n\n.docx-wrapper tr:nth-child(even) {\n    background-color: #f9f9f9;\n}\n\n.docx-wrapper tr:hover {\n    background-color: #f5f5f5;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
